import React from "react";
import { SchoolEvent } from "models/event";
import { School } from "models/school";
import { isIndividualSportEvent, isTeamSportEvent } from "helpers/event";
import Box from "@mui/material/Box";
import IndividualResultsTable from "./IndividualResultsTable";
import TeamResultsTable from "./TeamResultsTable";
import Typography from "@mui/material/Typography";
import {
  getEventResultForCalendar,
  shouldHideExactSchoolEventResult
} from "helpers/calendar";

interface Props {
  event: SchoolEvent;
  school: School;
}

export default function EventResults(props: Props) {
  const { event, school } = props;

  const isIndividualEvent = isIndividualSportEvent(event);
  const isTeamEvent = isTeamSportEvent(event);
  const shouldHideExactResult = shouldHideExactSchoolEventResult(
    event,
    school.id
  );

  const renderResults = () => {
    switch (true) {
      case isIndividualEvent:
        return <IndividualResultsTable event={event} school={school} />;

      case isTeamEvent:
        if (shouldHideExactResult) {
          return (
            <Box sx={{ py: 4, px: 2, textAlign: "center" }}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {getEventResultForCalendar(event, school.id)}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                The exact score is not published for this event.
              </Typography>
            </Box>
          );
        }
        return <TeamResultsTable event={event} school={school} />;

      default:
        return null;
    }
  };

  return <Box>{renderResults()}</Box>;
}
